import { useEffect, useState } from "react";
import SingleAlgoList from "./singleAlgoList";
import { getAlgorithmList } from "pages/dashboard/virtualGuard/service";
import { showToast } from "ui/components/common";

export default function AlgoSelection({ checkedAlgo, onCheckAlgo }) {
  const [algoTypes, setAlgoTypes] = useState([]);
  useEffect(() => {
    getAlgorithmList().then((data) => {
      if (data.status !== 200) {
        showToast(1, "Failed to get algorithm list");
      } else {
        setAlgoTypes(data.data.data);
      }
    });
  }, []);
  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        width: "100%",
      }}
    >
      {algoTypes.map((algoType, index) => {
        return (
          <SingleAlgoList
            key={algoType.name}
            title={algoType.display}
            algoList={algoType.algos}
            checkdAlgo={checkedAlgo}
            onCheckAlgo={onCheckAlgo}
            index={index}
          />
        );
      })}
    </div>
  );
}
